import { defineComponent } from 'vue'

import PointsPage from '@/organizations/_default/points'
import CosmoHeader from '@/organizations/cosmo/default/components/CosmoHeader.vue'
import CosmoFooter from '@/organizations/cosmo/default/components/CosmoFooter.vue'

export default defineComponent({
  extends: PointsPage,
  components: { 
    CosmoHeader, 
    CosmoFooter,
  },
  setup(props, context) {
    const page = PointsPage.setup(props, context)

    return {
      ...page,
    }
  }
})
